import React, { useState, useEffect } from "react";

const CartCheckSetting = ({ cartCheckData, handleSave }) => {
    const [couponApply, setCouponApply] = useState(true);
    const [coinApply, setCoinApply] = useState(true);

    useEffect(() => {
        if (cartCheckData) {
            setCouponApply(
                cartCheckData.coupon_apply !== undefined
                    ? cartCheckData.coupon_apply
                    : true
            );
            setCoinApply(
                cartCheckData.coin_apply !== undefined
                    ? cartCheckData.coin_apply
                    : true
            );
        }
    }, [cartCheckData]);

    const onSave = () => {
        handleSave({
            coupon_apply: couponApply,
            coin_apply: coinApply
        });
    };

    return (
        <div className="gst-setting-container">
            <label className="gst-setting-label">
                Cart Discount Settings
            </label>

            <div className="flex gap-6 mt-3">
                <label className="flex items-center gap-2 cursor-pointer">
                    <input
                        type="checkbox"
                        checked={couponApply}
                        onChange={(e) => setCouponApply(e.target.checked)}
                    />
                    Allow Coupon
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                    <input
                        type="checkbox"
                        checked={coinApply}
                        onChange={(e) => setCoinApply(e.target.checked)}
                    />
                    Allow Coin
                </label>
            </div>

            <button
                className="gst-setting-save-btn mt-4"
                onClick={onSave}
            >
                Save
            </button>
        </div>
    );
};

export default CartCheckSetting;
